import { useEffect, useState } from 'react'
import client from '../api/client'

interface SajuInfo {
  year_gan: string; year_ji: string
  month_gan: string; month_ji: string
  day_gan: string; day_ji: string
  time_gan: string | null; time_ji: string | null
  element_wood: number; element_fire: number
  element_earth: number; element_metal: number; element_water: number
  summary: string | null
}

interface DailyFortune {
  date: string
  year_gan: string; year_ji: string
  month_gan: string; month_ji: string
  day_gan: string; day_ji: string
}

const ELEMENT_COLOR: Record<string, string> = {
  목: 'text-green-400', 화: 'text-red-400',
  토: 'text-amber-400', 금: 'text-slate-300', 수: 'text-blue-400',
}
const ELEMENT_BG: Record<string, string> = {
  목: 'bg-green-900/30', 화: 'bg-red-900/30',
  토: 'bg-amber-900/30', 금: 'bg-slate-700/30', 수: 'bg-blue-900/30',
}

export default function SajuCard() {
  const [saju, setSaju] = useState<SajuInfo | null>(null)
  const [daily, setDaily] = useState<DailyFortune | null>(null)

  useEffect(() => {
    client.get('/users/me/saju').then((r) => setSaju(r.data)).catch(() => {})
    client.get('/saju/daily').then((r) => setDaily(r.data)).catch(() => {})
  }, [])

  if (!saju) return null

  const elements = [
    { label: '목', value: saju.element_wood },
    { label: '화', value: saju.element_fire },
    { label: '토', value: saju.element_earth },
    { label: '금', value: saju.element_metal },
    { label: '수', value: saju.element_water },
  ]
  const total = elements.reduce((s, e) => s + e.value, 0)

  return (
    <div className="bg-[var(--color-surface)] border border-[var(--color-border-default)] rounded-2xl p-4 space-y-3">
      <h3 className="text-sm font-semibold text-[var(--color-accent)]">🏪 내 운명 카드</h3>

      {/* 사주팔자 */}
      <div className="grid grid-cols-4 gap-1.5">
        {[
          { label: '년', gan: saju.year_gan, ji: saju.year_ji },
          { label: '월', gan: saju.month_gan, ji: saju.month_ji },
          { label: '일', gan: saju.day_gan, ji: saju.day_ji },
          { label: '시', gan: saju.time_gan ?? '?', ji: saju.time_ji ?? '?' },
        ].map((p) => (
          <div key={p.label} className="bg-[var(--color-bg)] border border-[var(--color-border-default)] rounded-xl p-2 text-center">
            <div className="text-xs text-[var(--color-text-tertiary)] mb-1">{p.label}</div>
            <div className="text-[var(--color-accent)] font-bold">{p.gan}</div>
            <div className="text-[var(--color-text-secondary)] text-sm">{p.ji}</div>
          </div>
        ))}
      </div>

      {/* 오행 분포 */}
      <div className="flex gap-1.5">
        {elements.map((e) => (
          <div key={e.label} className={`flex-1 rounded-lg py-1.5 text-center ${ELEMENT_BG[e.label]}`}>
            <div className={`text-xs font-bold ${ELEMENT_COLOR[e.label]}`}>{e.label}</div>
            <div className="text-xs text-[var(--color-text-tertiary)]">{total > 0 ? Math.round(e.value / total * 100) : 0}%</div>
          </div>
        ))}
      </div>

      {/* 오늘 일진 */}
      {daily && (
        <div className="border-t border-[var(--color-border-default)] pt-3">
          <div className="text-xs text-[var(--color-text-tertiary)] mb-1.5">오늘 일진 ({daily.date})</div>
          <div className="flex gap-2 text-xs text-[var(--color-text-secondary)] flex-wrap">
            <span>년운 <strong className="text-[var(--color-accent)]">{daily.year_gan}{daily.year_ji}</strong></span>
            <span>월운 <strong className="text-[var(--color-accent)]">{daily.month_gan}{daily.month_ji}</strong></span>
            <span>일진 <strong className="text-[var(--color-accent)]">{daily.day_gan}{daily.day_ji}</strong></span>
          </div>
        </div>
      )}
    </div>
  )
}
